import React from "react";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import { Outlet, useSearchParams } from "react-router-dom";
import QueryParamKey from "shared/enums/QueryParamKey";
import { ApplicableViewEnum } from "./buyTicketFormDetails/constants";
import { useCopies } from "shared/hooks/useCopies";
import { Modal, ModalBody, ModalHeader } from "shared/components/modal";
import Size from "shared/enums/Size";
import GenericInfoDetails from "./buyTicketFormDetails/genericInfoDetails";
import { useGetApplicableFormsList } from "./dataloader";
import { useParticipantDetails } from "../../context/participantDetails";
import { MyExpRoute } from "apps/myExperience/routes/types";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";

export default function TicketChange() {
  const copies = useCopies();
  useLogAnalyticsScreenHook({ properties: { screenType: AnalyticsScreenNameEnum.UPGRADE_TICKET } });
  const { navigate } = useNavigateWrapper();
  const [searchParams] = useSearchParams();
  const { participantDetails } = useParticipantDetails();
  const { data: applicableFormsList } = useGetApplicableFormsList(participantDetails?.registrationParticipantId, () =>
    navigate(MyExpRoute.HOME.path)
  );

  const isConfirmationView = React.useMemo(
    () => searchParams.get(QueryParamKey.VIEW_TYPE) === ApplicableViewEnum.CONFIRMATION.toString(),
    [searchParams]
  );

  const isPaymentActionPending = React.useMemo(
    () => searchParams.get(QueryParamKey.REQUEST_PENDING) === "true",
    [searchParams]
  );

  const modalCloseHandler = React.useCallback(() => {
    navigate(MyExpRoute.HOME.path);
  }, [navigate]);

  if (!applicableFormsList) {
    return null;
  }
  return (
    <Modal className="ticketUpgradeModal" size={Size.LARGE}>
      <ModalHeader
        left={
          <React.Fragment>
            <span>{copies.get("ticket.change.label")}</span>
            {!isConfirmationView && <GenericInfoDetails />}
          </React.Fragment>
        }
        onClose={!isConfirmationView || isPaymentActionPending ? modalCloseHandler : undefined}
      />
      <ModalBody className="ticketUpgradeModal_body">
        <Outlet context={{ applicableFormsList }} />
      </ModalBody>
    </Modal>
  );
}
